import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Label,
  List,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { required, numericRange } from '@mhub/web-validations';
import AppForm from '../../../components/AppForm';

export default class FormulaDropdownInput extends Component {
  static propTypes = {
    data: PropTypes.shape(),
    onChange: PropTypes.func.isRequired,
    refValidation: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      helpModalIsOpen: false,
    };
  }
  getFormulaTypes = (data) => {
    if (data.orderPriority > 1) {
      return [
        { text: 'Deduct percentage of selling price', value: 'discount_percent_original_price' },
        { text: 'Deduct percentage of selling price (Round Up Decimals)', value: 'discount_percent_original_price_round_up' },
        { text: 'Deduct percentage of selling price (Round Down Decimals)', value: 'discount_percent_original_price_round_down' },
        { text: 'Deduct percentage of selling price (Round Up Ringgit)', value: 'discount_percent_original_price_round_up_ringgit' },
        { text: 'Deduct percentage of selling price (Round Down Ringgit)', value: 'discount_percent_original_price_round_down_ringgit' },
        { text: 'Deduct percentage of above formula total', value: 'discount_percent_previous_item' },
        { text: 'Deduct percentage of above formula total (Round Up Decimals)', value: 'discount_percent_previous_item_round_up' },
        { text: 'Deduct percentage of above formula total (Round Down Decimals)', value: 'discount_percent_previous_item_round_down' },
        { text: 'Deduct percentage of above formula total (Round Up Ringgit)', value: 'discount_percent_previous_item_round_up_ringgit' },
        { text: 'Deduct percentage of above formula total (Round Down Ringgit)', value: 'discount_percent_previous_item_round_down_ringgit' },
        { text: 'Deduct fixed amount', value: 'discount_fixed_amount' },
        { text: 'Add percentage of selling price', value: 'add_percent_original_price' },
        { text: 'Add percentage of selling price (Round Up Decimals)', value: 'add_percent_original_price_round_up' },
        { text: 'Add percentage of selling price (Round Down Decimals)', value: 'add_percent_original_price_round_down' },
        { text: 'Add percentage of selling price (Round Up Ringgit)', value: 'add_percent_original_price_round_up_ringgit' },
        { text: 'Add percentage of selling price (Round Down Ringgit)', value: 'add_percent_original_price_round_down_ringgit' },
        { text: 'Add percentage of above\'s formula total', value: 'add_percent_previous_item' },
        { text: 'Add percentage of above\'s formula total (Round Up Decimals)', value: 'add_percent_previous_item_round_up' },
        { text: 'Add percentage of above\'s formula total (Round Down Decimals)', value: 'add_percent_previous_item_round_down' },
        { text: 'Add percentage of above\'s formula total (Round Up Ringgit)', value: 'add_percent_previous_item_round_up_ringgit' },
        { text: 'Add percentage of above\'s formula total (Round Down Ringgit)', value: 'add_percent_previous_item_round_down_ringgit' },
        { text: 'Add fixed amount', value: 'add_fixed_amount' },
        { text: 'Custom Formula', value: 'custom_formula', disabled: true },
      ];
    }
    return [
      { text: 'Deduct percentage of selling price', value: 'discount_percent_original_price' },
      { text: 'Deduct percentage of selling price (Round Up Decimals)', value: 'discount_percent_original_price_round_up' },
      { text: 'Deduct percentage of selling price (Round Down Decimals)', value: 'discount_percent_original_price_round_down' },
      { text: 'Deduct percentage of selling price (Round Up Ringgit)', value: 'discount_percent_original_price_round_up_ringgit' },
      { text: 'Deduct percentage of selling price (Round Down Ringgit)', value: 'discount_percent_original_price_round_down_ringgit' },
      { text: 'Deduct percentage of above formula total', value: 'discount_percent_previous_item', disabled: true },
      { text: 'Deduct percentage of above formula total (Round Up Decimals)', value: 'discount_percent_previous_item_round_up', disabled: true },
      { text: 'Deduct percentage of above formula total (Round Down Decimals)', value: 'discount_percent_previous_item_round_down', disabled: true },
      { text: 'Deduct percentage of above formula total (Round Up Ringgit)', value: 'discount_percent_previous_item_round_up_ringgit', disabled: true },
      { text: 'Deduct percentage of above formula total (Round Down Ringgit)', value: 'discount_percent_previous_item_round_down_ringgit', disabled: true },
      { text: 'Deduct fixed amount', value: 'discount_fixed_amount' },
      { text: 'Add percentage of selling price', value: 'add_percent_original_price' },
      { text: 'Add percentage of selling price (Round Up Decimals)', value: 'add_percent_original_price_round_up' },
      { text: 'Add percentage of selling price (Round Down Decimals)', value: 'add_percent_original_price_round_down' },
      { text: 'Add percentage of selling price (Round Up Ringgit)', value: 'add_percent_original_price_round_up_ringgit' },
      { text: 'Add percentage of selling price (Round Down Ringgit)', value: 'add_percent_original_price_round_down_ringgit' },
      { text: 'Add percentage of above\'s formula total', value: 'add_percent_previous_item', disabled: true },
      { text: 'Add percentage of above\'s formula total (Round Up Decimals)', value: 'add_percent_previous_item_round_up', disabled: true },
      { text: 'Add percentage of above\'s formula total (Round Down Decimals)', value: 'add_percent_previous_item_round_down', disabled: true },
      { text: 'Add percentage of above\'s formula total (Round Up Ringgit)', value: 'add_percent_previous_item_round_up_ringgit', disabled: true },
      { text: 'Add percentage of above\'s formula total (Round Down Ringgit)', value: 'add_percent_previous_item_round_down_ringgit', disabled: true },
      { text: 'Add fixed amount', value: 'add_fixed_amount' },
      { text: 'Custom Formula', value: 'custom_formula' },
    ];
  }
  getFormulaTypeValidation = (data) => {
    switch (data.formulaType) {
      case 'discount_percent_original_price':
      case 'discount_percent_original_price_round_up':
      case 'discount_percent_original_price_round_down':
      case 'discount_percent_original_price_round_up_ringgit':
      case 'discount_percent_original_price_round_down_ringgit':
      case 'discount_percent_previous_item':
      case 'discount_percent_previous_item_round_up':
      case 'discount_percent_previous_item_round_down':
      case 'discount_percent_previous_item_round_up_ringgit':
      case 'discount_percent_previous_item_round_down_ringgit':
      case 'add_percent_original_price':
      case 'add_percent_original_price_round_up':
      case 'add_percent_original_price_round_down':
      case 'add_percent_original_price_round_up_ringgit':
      case 'add_percent_original_price_round_down_ringgit':
      case 'add_percent_previous_item':
      case 'add_percent_previous_item_round_up':
      case 'add_percent_previous_item_round_down':
      case 'add_percent_previous_item_round_up_ringgit':
      case 'add_percent_previous_item_round_down_ringgit':
        return [required, {
          validate: numericRange,
          option: {
            min: 0.01,
            max: 100,
          },
        }];
      case 'discount_fixed_amount':
      case 'add_fixed_amount':
        return [required, {
          validate: numericRange,
          option: {
            min: 0.00,
            max: 2147483647,
          },
        }];
      case 'custom_formula':
        return [required];
      default:
        return null;
    }
  }
  getFormulaValuePlaceholder = (data) => {
    switch (data.formulaType) {
      case 'discount_percent_original_price':
      case 'discount_percent_previous_item':
        return 'Deduct percent';
      case 'discount_percent_original_price_round_up':
      case 'discount_percent_previous_item_round_up':
        return 'Deduct percent (round up decimals)';
      case 'discount_percent_original_price_round_up_ringgit':
      case 'discount_percent_previous_item_round_up_ringgit':
        return 'Deduct percent (round up ringgit)';
      case 'discount_percent_original_price_round_down':
      case 'discount_percent_previous_item_round_down':
        return 'Deduct percent (round down decimals)';
      case 'discount_percent_original_price_round_down_ringgit':
      case 'discount_percent_previous_item_round_down_ringgit':
        return 'Deduct percent (round down ringgit)';
      case 'discount_fixed_amount':
        return 'Deduct amount';
      case 'add_percent_original_price':
      case 'add_percent_previous_item':
        return 'Additional percent';
      case 'add_percent_original_price_round_up':
      case 'add_percent_previous_item_round_up':
        return 'Additional percent (round up decimals)';
      case 'add_percent_original_price_round_up_ringgit':
      case 'add_percent_previous_item_round_up_ringgit':
        return 'Additional percent (round up ringgit)';
      case 'add_percent_original_price_round_down':
      case 'add_percent_previous_item_round_down':
        return 'Additional percent (round down decimals)';
      case 'add_percent_original_price_round_down_ringgit':
      case 'add_percent_previous_item_round_down_ringgit':
        return 'Additional percent (round down ringgit)';
      case 'add_fixed_amount':
        return 'Additional amount';
      case 'custom_formula':
        return 'Custom formula';
      default:
        return '';
    }
  }
  handleOnChange = (e, value) => {
    if (this.props.onChange) {
      this.props.onChange(e, value);
    }
  }
  handleHelpModal = (e) => {
    e.preventDefault();
    this.setState({
      helpModalIsOpen: true,
    });
  }
  handleHelpModalClose = () => {
    this.setState({
      helpModalIsOpen: false,
    });
  }
  render() {
    const { data } = this.props;
    const { helpModalIsOpen } = this.state;
    return (
      <Grid>
        <Modal open={helpModalIsOpen} size="small" onClose={this.handleHelpModalClose}>
          <Header icon="help" content="Custom Formula Help" />
          <Modal.Content>
            <b>Formula Operators & Syntax</b><br />
            <List>
              <List.Item><Label size="small">+</Label> Addition.<br /></List.Item>
              <List.Item><Label size="small">-</Label> Subtraction.<br /></List.Item>
              <List.Item><Label size="small">*</Label> Multiplication.<br /></List.Item>
              <List.Item><Label size="small">/</Label> Division.<br /></List.Item>
              <List.Item><Label size="small">.</Label> Decimal point for cents.<br /></List.Item>
              <List.Item><Label size="small">(</Label> <Label size="small">)</Label> Parenthesis to control order of evaluation.<br /></List.Item>
              <List.Item><Label size="small">SPA_VALUE</Label> or <Label size="small">SELLING_PRICE</Label> Selling price of unit.</List.Item>
              <List.Item><Label size="small">ROUND(value)</Label> Rounds cents to the nearest ones.</List.Item>
              <List.Item><Label size="small">CEIL(value)</Label> Rounds cents up to the nearest ones.</List.Item>
              <List.Item><Label size="small">FLOOR(value)</Label> Rounds cents down to the nearest ones.</List.Item>
              <List.Item><Label size="small">PERCENT(value, percentage)</Label> Get percent of value.</List.Item>
              <List.Item><Label size="small"><strike>TIER(&#34;Tier Name&#34;)</strike></Label> <strike>Get value of another tier.</strike></List.Item>
            </List>
            <b>Examples</b><br />
            <List>
              <List.Item><Label size="small">SPA Value-3%-7%-2%-RM500</Label> would be <Label color="grey" size="small">(((SPA_VALUE*(1-0.03))*(1-0.07))*(1-0.02))-500</Label></List.Item>
              <List.Item><Label size="small">RM250,000.00</Label> would be <Label color="grey" size="small">250000.00</Label></List.Item>
            </List>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleHelpModalClose}>
              Close
                </Button>
          </Modal.Actions>
        </Modal>
        <Grid.Row className="row_formula_dropdown_input">
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="label_formula_type">Formula Type</div>
            <Dropdown
              fluid
              name="formulaType"
              onChange={this.handleOnChange}
              options={this.getFormulaTypes(data)}
              placeholder="Select Formula Type"
              ref={this.props.refValidation}
              selection
              value={data.formulaType}
            />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <AppForm.Input
              label="Formula Value"
              name="formulaValue"
              onChange={this.handleOnChange}
              placeholder={this.getFormulaValuePlaceholder(data)}
              ref={this.props.refValidation}
              step={data.formulaType === 'custom_formula' ? null : '.01'}
              type={data.formulaType === 'custom_formula' ? 'text' : 'number'}
              validateLabel="Formula Value"
              validation={this.getFormulaTypeValidation(data)}
              value={data.formulaValue}
              icon={data.formulaType === 'custom_formula' ? (
                <Icon name="help" fitted inverted color="teal" className="icon_custom_formula_help" circular onClick={this.handleHelpModal} />
              ) : null}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/FormulaDropdownInput.jsx